'use strict';

var Menu = function($target) {

	function init() {
        var $subMenu = $target.find('.menu-item-155 .sub-menu');

		$target.find('.menu-item-155 > a').on('click', function(e) {
            e.preventDefault();
            $subMenu.toggle();
		});
	}

	init();
}

module.exports = Menu;